import React, { Component } from 'react';
import ConvertDocQueryV2      from '../convertDocQueryV2';
import urlHandler           from '../../../utils/urlHandler';
import perms                from '../../../utils/permissions';
import examples from '../../../utils/examples';
import {Link} from 'react-router-dom';

class DocV2ConvertDoc extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_CONVERT_DOC)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span id="convertdocv2_endpoint">
                    <span className='heading-1'>Convert Document</span>
                </span>
                <code className="api-definition">
                    <span className="put-badge">PUT</span>&nbsp;{urlHandler.API_ENDPOINT_V2_CONVERT_DOC}
                </code>
                <div className="description">
                    The v2 convert-doc endpoint extracts text from a given file. Supported file formats include:
                    <br/>
                    <br/>
                    <table>
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>File Types</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Plaintext</td>
                                <td>.eml, .html, .md, .msg, .rst, .rtf, .txt, .xml</td>
                            </tr>
                            <tr>
                                <td>Images</td>
                                <td>.png, .jpg, .jpeg, .tiff, .bmp, .heic</td>
                            </tr>
                            <tr>
                                <td>Documents&emsp;</td>
                                <td>.csv, .doc, .docx, .epub, .odt, .pdf, .ppt, .pptx, .tsv, .xlsx</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4 className="heading-2" id="convertdocv2_request">Request</h4>
                <div className="description">
                    The v2 convert-doc request is body consists of the raw bytes of the file to extract the text from. Currently the only
                    supported <i>Content-Type</i> header is <i>application/octet-stream</i> which supports HTML and PDF files.
                </div>
                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                    PUT {urlHandler.API_ENDPOINT_V2_CONVERT_DOC}<br/>
                    Accept: application/json<br/>
                    Authorization: Bearer [YOUR-API-KEY]<br/>
                    Content-Type: application/octet-stream<br/>
                    </pre>
                </div>
                <h4 className="heading-2" id="convertdocv2_response">Response</h4>
                <div className="description">
                  The convert-doc response is a JSON Object containing the keys "text" and "elements" and can be used in processes and endpoints that support it. The convertedDoc.text can be used in place of text element in the <Link to="/documentation/doc_v2enrich">/api/v2/enrich</Link> endpoint.
                </div>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                    {JSON.stringify(examples.EXAMPLE_RESPONSE_V2_CONVERT_DOC, null, 3)}
                    </pre>
                </div>
                {this.state.dynamicSample &&
                    <div>
                        <br/>
                        <ConvertDocQueryV2/>
                    </div>
                }
            </div>
        );
    }
}

export default DocV2ConvertDoc;